import React from 'react';
import Button from '../../../components/Button';
import Container from '../../../components/Container';
import Section from '../../../components/Section';

export default ({ policyAction, handlePolicyContinueButton, showPolicyCheckNotice }) => (
    <Section>
        <Container>
            <h2>Disclaimer</h2>
            <p>
                Before we can start recording your answers we need you to confirm our{' '}
                <a href="http://r-squared.ch/fair-processing-notice" target="_blank">
                    Fair Processing Notice / Privacy Policy
                </a>. As you upload videos and documents we will collect personal data from you for a limited period of
                time. In accordance to GDPR rule, we will take care to protect your data and keep it secure. You can
                instruct us to handout or delete your data at any time. You hereby agree that we can share your video
                responses with the hiring manager and Human Resources.
            </p>
            <div>
                <input id="agree" type="checkbox" onChange={e => policyAction(e.target.checked, false)} />{' '}
                <label htmlFor="agree">
                    I agree to the{' '}
                    <a href="http://r-squared.ch/fair-processing-notice" target="_blank">
                        Fair Processing Notice / Privacy Policy
                    </a>
                </label>
            </div>
            <p>
                <Button onClick={handlePolicyContinueButton}>Continue</Button>{' '}
                {showPolicyCheckNotice && 'Please accept the privacy policy before you continue.'}
            </p>
        </Container>
    </Section>
);



// WEBPACK FOOTER //
// ./src/scenes/candidate/components/Disclaimer.tsx